import React from 'react';
import { Icon, Spinner } from '@chakra-ui/react';
import { isFile } from 'utils/index';
import { BiImage } from 'react-icons/bi';
import { AiOutlineClose, AiOutlineFilePdf } from 'react-icons/ai';
import { errorToast, successToast, FILE_TYPES_PATTERN, FILE_SIZE_LIMIT } from 'constants/index';
import { viewDateAndTime } from 'utils/date';
import 'assets/css/file.scss';

export default function FileInput({
    setfile,
    title,
    file,
    data,
    required = false ,
    label = 'Document',
    isPreview = false,
    handleRemove,
    isLoading,
    handleView
}) {
    // File
    const [imageError, setimageError] = React.useState(false);
    const [row, setrow] = React.useState({ label: '', updatedAt: null });
    // upload file section  is here
    const handleUpload = (e) => {
        const selectedFile = e.target.files?.[0] || null;

        const size = (selectedFile.size / 1024 / 1024).toFixed(2);
        const types = FILE_TYPES_PATTERN;

        if (size > FILE_SIZE_LIMIT) {
            errorToast(`File size should be less than ${FILE_SIZE_LIMIT} MB.`);
            return;
        }
        if (selectedFile && selectedFile.name && !types.test(selectedFile.type)) {
            errorToast('Invalid file.');
            return;
        }
        setimageError(false);
        setrow({ updatedAt: new Date() });
        setfile(selectedFile);
        successToast(`${label} selected successfully.`);
    };

    const onClickView = ()=>{
        if (handleView) {
            handleView();
        } else {
            if (isFile(file)) {
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');
            } else {
                const link = document.createElement('a');
                link.href = file || row.url || row.logo;
                link.target = 'blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    const handleImageError = ()=>{
        setimageError(true);
    };
    const handleBrowse = ()=>{
        let input = document.getElementById('file-select-input');
        input.click();
    };

    React.useEffect(() => {
        if (data?.logo) {
            setfile(data.logo);
            setrow({ updatedAt: data?.updatedAt });
        }
    }, [data]);

    const FileRecord = () => {
        if (isLoading) {
            return (
                <React.Fragment>
                    <Spinner size={20} />
                </React.Fragment>
            );
        } else if (file && imageError) {
            return (
                <React.Fragment>
                    <AiOutlineFilePdf className='icon  primary-text'/>
                    {
                        !isPreview &&
                            <Icon color='primary' disabled={isLoading } onClick={handleRemove} className='close-icon'>
                                <AiOutlineClose aria-disabled={ isLoading } onClick={handleRemove} />
                            </Icon>
                    }
                </React.Fragment>
            );
        } else if (file) {
            return (
                <React.Fragment>
                    <img onError={handleImageError} src={isFile(file) ? URL.createObjectURL(file) : file} decoding='async' loading='lazy' alt={row?.label || 'Document preview'} className='icon' />
                    {
                        !isPreview && <Icon color='primary' disabled={isLoading} onClick={handleRemove} className='close-icon'>
                            <AiOutlineClose aria-disabled={ isLoading } onClick={handleRemove} />
                        </Icon>
                    }
                </React.Fragment>
            );
        } else {
            return (
                <BiImage className='icon'/>
            );
        }
    };
    return (
        <div className='content-box dropzone-area' >
            <input style={{ visibility: 'hidden' }} type='file' max={1} id='file-select-input' onChange={handleUpload} />
            <div className= { file ? 'file-select-row-wrapper space-between-box select-success' : 'file-select-row-wrapper space-between-box'} >
                <div className='icon-box'>
                    <FileRecord/>
                </div>
                <div className='text-box'>
                    <p >{title}{ required && <span className='required'> *</span>}</p>
                    {
                        (row?.updatedAt)
                            ? <p>
                            Selected On : {viewDateAndTime(row?.updatedAt)}
                            </p>
                            : <p>PNG, JPG or PDF, not larger than {FILE_SIZE_LIMIT}MB in size</p>
                    }
                </div>
                {
                    file &&
                    <button type='button' disabled={isLoading } onClick={() => onClickView(row)} className='browse-button'>View</button>
                }
                {
                    !isPreview &&
                <button onClick={handleBrowse} disabled={isLoading} type='button' className='browse-button'> {isLoading ? 'Uploading...' : 'Browse'}</button>
                }
                {
                    file && <button type='button' disabled={isLoading } className='remove-button' onClick={handleRemove}>Remove</button>
                }

            </div>
        </div>
    );
}
